import React, { useState } from "react";
import BottomNav from "./BottomNav";
import { UserDataProvider, useUserDataCtx } from "../../context/UserDataContext";
import Loader from "../common/Loader";
import Home from "../../pages/Home";
import PackagesPage from "../../pages/PackagesPage";
import TeamPage from "../../pages/TeamPage";
import ScnPage from "../../pages/ScnPage";

// The authenticated app: tabs + shared data + bottom navigation.
// Rendered by NetworkGuard only when connected on the correct network.
function Shell() {
  const [tab, setTab] = useState("home");
  const { data, loading, refresh } = useUserDataCtx();

  let body;
  if (!data && loading) {
    body = <Loader text="Loading your dashboard" fullscreen={false} />;
  } else if (!data) {
    body = (
      <div className="card center" style={{ marginTop: 24 }}>
        <p className="muted">Unable to load data.</p>
        <button className="btn mt-4" onClick={refresh}>Retry</button>
      </div>
    );
  } else {
    const pageProps = { data, refresh, goTab: setTab };
    if (tab === "home") body = <Home {...pageProps} />;
    else if (tab === "packages") body = <PackagesPage {...pageProps} />;
    else if (tab === "team") body = <TeamPage {...pageProps} />;
    else if (tab === "scn") body = <ScnPage {...pageProps} />;
  }

  return (
    <>
      <main className="app-content">
        <div key={tab} className="page-enter">{body}</div>
      </main>
      <BottomNav active={tab} onChange={setTab} />
    </>
  );
}

export default function AuthedApp() {
  return (
    <UserDataProvider>
      <Shell />
    </UserDataProvider>
  );
}
